import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useCart } from '../context/CartContext';

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    navigate('/checkout');
  };

  const incrementQuantity = (productId, currentQuantity) => {
    updateQuantity(productId, currentQuantity + 1);
  };

  const decrementQuantity = (productId, currentQuantity) => {
    if (currentQuantity > 1) {
      updateQuantity(productId, currentQuantity - 1);
    }
  };

  return (
    <>
      <Helmet>
        <title>Shopping Cart - Tanarela</title>
        <meta name="description" content="Review your selected landscape design materials and proceed to checkout." />
        <link rel="canonical" href="https://tanarela.com/cart" />
      </Helmet>

      <section className="cart-section">
        <div className="cart-container">
          <h1>Your Shopping Cart</h1>

          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <p>Your cart is currently empty</p>
              <Link to="/">Continue Shopping</Link>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cartItems.map(item => (
                  <div key={item.id} className="cart-item">
                    <img 
                      src={item.image} 
                      alt={item.name} 
                      className="cart-item-image"
                    />
                    <div className="cart-item-details">
                      <h3>{item.name}</h3>
                      <p className="cart-item-price">AU${item.price}</p>
                      <div className="cart-item-quantity">
                        <div className="quantity-controls">
                          <button 
                            onClick={() => decrementQuantity(item.id, item.quantity)}
                            className="quantity-btn"
                          >
                            -
                          </button>
                          <span className="quantity-value">{item.quantity}</span>
                          <button 
                            onClick={() => incrementQuantity(item.id, item.quantity)}
                            className="quantity-btn"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="cart-item-actions">
                      <div className="cart-item-total">
                        AU${(item.price * item.quantity).toFixed(2)}
                      </div>
                      <button 
                        onClick={() => removeFromCart(item.id)}
                        className="remove-btn"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="cart-summary">
                <h2>Order Summary</h2>
                <div className="summary-row">
                  <span className="summary-label">Subtotal:</span>
                  <span className="summary-value">AU${getCartTotal().toFixed(2)}</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Shipping:</span>
                  <span className="summary-value">Calculated at checkout</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Total:</span>
                  <span className="summary-total">AU${getCartTotal().toFixed(2)}</span>
                </div>
                <button onClick={handleCheckout} className="checkout-btn">
                  Proceed to Checkout
                </button>
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
}

export default Cart;